module.exports = __webpack_public_path__ + "static/media/img-127.0c471e37.jpg";